import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';
import { useSMLCountryParam } from './useSMLCountryParam';

interface UseTrackPlaylistAdditionsProps {
  trackId: string;
  date?: Date;
}

export const useTrackPlaylistAdditions = ({ trackId, date }: UseTrackPlaylistAdditionsProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  const { countryCode } = useSMLCountryParam();

  const playlistAdditionsQuery = useTRPCQuery(
    trpcMusicAPI.tracks.playlistAdditions.queryOptions({
      trackId,
      date,
      // Public share links pin the global view.
      countryCode: shareTokenInput.shareToken !== undefined ? undefined : countryCode,
      ...shareTokenInput,
    })
  );

  return playlistAdditionsQuery;
};
